import { render, staticRenderFns } from "./chart_component.vue?vue&type=template&id=5642979b&scoped=true"
import script from "./chart_component.vue?vue&type=script&lang=js"
export * from "./chart_component.vue?vue&type=script&lang=js"
import style0 from "./chart_component.vue?vue&type=style&index=0&id=5642979b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642979b",
  null
  
)

export default component.exports